import styled from 'styled-components';

export const ChatContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background-color: #181818;
  overflow-x: hidden;
`;

export const ChatMessages = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px;
  padding-bottom: 105px;

  @media (max-width: 600px) {
    padding-left: 5%;
    padding-right: 5%;
  }

  @media (min-width: 601px) and (max-width: 1200px) {
    padding-left: 10%;
    padding-right: 10%;
  }

  @media (min-width: 1201px) {
    padding-left: 20%;
    padding-right: 20%;
  }

  background-color: #181818;
  box-sizing: border-box;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const MessageWithSpinner = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  span {
    margin-left: 10px;
  }
`;

export const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  margin-left: ${({ type }) => (type === 'candidate' ? '10px' : '0')};
  margin-right: ${({ type }) => (type === 'coach' ? '10px' : '0')};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const StartButton = styled.button`
  background-color: #000;
  color: #fff;
  padding: 15px 30px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #333;
  }

  &:focus {
    outline: none;
  }
`;

export const ShareButton = styled.button`
  background-color: #482987;
  color: #fff;
  padding: 15px 30px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #333;
  }

  &:focus {
    outline: none;
  }
`;

export const PresentationMessage = styled.div`
  color: black;
  text-align: center;
  margin-bottom: 20px;
  align-items: center;
  @media (max-width: 600px) {
    width: 320px;
  }

  @media (min-width: 601px) and (max-width: 1200px) {
    width: 450px;
  }

  @media (min-width: 1201px) {
    width: 700px;
  }
`;

export const InitialContainer = styled.div`
  border: 1px solid black;
  border-radius: 25px;
  padding: 40px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 3px 4px 8px rgba(0.1, 0.1, 0.1, 0.5);

  @media (max-width: 600px) {
    margin-top: -50px;
    padding: 20px;
  }

  @media (min-width: 601px) and (max-width: 1200px) {
    margin-top: -70px;
  }

  @media (min-width: 1201px) {
    margin-top: -190px;
  }

`;